import { Icon } from '@chakra-ui/react';

export const Bolt = (props) => (
  <Icon viewBox="0 0 16 16" boxSize="16px" color="icon.g1" {...props}>
    <path
      d="M8.01154 12.0762C7.90677 12.2464 7.6431 12.1708 7.64091 11.97L7.60705 8.8773C7.60601 8.78197 7.56359 8.69056 7.48914 8.62315C7.41469 8.55575 7.3143 8.51788 7.21005 8.51788H5.11184C4.94918 8.51788 4.85254 8.33404 4.94561 8.20168L7.99876 3.85977C8.11133 3.69969 8.36473 3.78348 8.3628 3.98014L8.33195 7.11431C8.33143 7.16211 8.34134 7.20962 8.36111 7.25406C8.38088 7.29849 8.41011 7.33897 8.44709 7.37311C8.48407 7.40725 8.52805 7.43437 8.57646 7.45288C8.62487 7.47139 8.67674 7.48092 8.72903 7.48091H10.4797C10.6369 7.48091 10.7346 7.6539 10.6526 7.78709L8.01154 12.0762Z"
      fill="currentColor"
    />
  </Icon>
);
